import { useApi } from '../services';

export const useCalculateSync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/premium-calculation`,
    'POST',
    {},
    {},
    true
);

export const useRecalculateSync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/premium-calculation`,
    'PUT',
    {},
    {}
);

export const useCommissionRate = (idOperation) => useApi(
    `/v2/operation/${idOperation}/premium-calculation/comission`,
    'GET',
    {},
    {}
);

export const useMaxLimClaim = (idOperation) => useApi(
    `/v2/operation/${idOperation}/premium-calculation/max-lim-claim`,
    'GET',
    {},
    {},
    true
);
